import React from "react";

/**
 * Action button area inside a live-chat message bubble.
 * Background matches the bubble (green outbound / white inbound).
 */
export function MessageBubbleButtonFooter({
  children,
  isOutbound = true,
  className = "",
}) {
  if (!children) return null;

  const bg = isOutbound ? "bg-[#d9fdd3]" : "bg-white";

  return (
    <div
      className={`-mx-2.5 sm:-mx-3 -mb-1.5 sm:-mb-2 px-2 pb-2 flex flex-col gap-1.5 ${bg} ${className}`}
    >
      <div
        className="border-t border-[rgba(17,27,33,0.08)] mt-3 mb-3"
        role="separator"
        aria-hidden="true"
      />
      {children}
    </div>
  );
}
